<template>
<div class="chapter">
<div class="inner_page">
<div id="titlepage">
<p class="booktitle"><span class="red">SLOW FIRE</span></p>
<p class="subtitle">THE BEGINNER’S GUIDE TO BARBECUE</p>
<p class="author"><span class="red">BY RAY “DR. BBQ” LAMPE</span></p>
<p class="othertext">FOREWORD BY FAMOUS DAVE ANDERSON<br/>PHOTOGRAPHS BY LEIGH BEISCH</p>
<p class="publogo"><img alt="publisher logo" src="images/logo.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002titlepage.vue?667dd0c4